import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-c', 'IconCircleLetterC', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0', key: 'svg-1' }],
]);
